import $ from 'jquery';
import config from '../app-config';

function setTopnav() {
    const activeClass = 'is-active';

    const topnav = $('.js-topnav');
    const trigger = $('.js-topnav-trigger');

    let isClicked = false;

    trigger.on('click', function eventOnClick(event) {
        if ($(window).width() < config.breakpoints.medium) {
            event.preventDefault();

            if (!isClicked) {
                $(this).add(topnav).addClass(activeClass);
            } else {
                topnav.removeClass(activeClass);
                trigger.removeClass(activeClass);
            }

            isClicked = !isClicked;
        }
    });

    trigger.on('mouseenter', function eventOnClick() {
        if ($(window).width() >= config.breakpoints.medium) {
            topnav.addClass(activeClass);
        }
    });

    topnav.on('mouseleave', function eventOnClick() {
        if ($(window).width() >= config.breakpoints.medium) {
            topnav.removeClass(activeClass);
        }
    });
}

function init() {
    if ($('.js-topnav').length > 0) setTopnav();
}

export { init };


// WEBPACK FOOTER //
// ./src/_app/layout/topnav.js